// extracted by mini-css-extract-plugin
export var createdDate = "_ns-1";
export var divider = "_ns-2";
export var headerDivider = "_ns-3";
export var messagesCard = "_ns-0";
export var messagesContainer = "_ns-7";
export var messagesContainerWrapper = "_ns-4";
export var pointerCapturingButtonBoxes = "_ns-a";
export var showLeftPanelButton = "_ns-9";
export var showMoreButton = "_ns-c";
export var showMoreButtonContainer = "_ns-b";
export var summaryTitle = "_ns-6";
export var systemMessageCardWrapper = "_ns-d";
export var topButtons = "_ns-8";
export var withPadding = "_ns-5";